import {
  Component, Input, OnChanges, OnDestroy,
  AfterViewInit, ViewChild, ElementRef
} from '@angular/core';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-chart',
  template: `
    <div class="chart-canvas-wrapper">
      <canvas #chartCanvas></canvas>
    </div>
  `,
  styles: [`
    .chart-canvas-wrapper {
      position: relative;
      width: 100%;
      height: 100%;
    }
    canvas {
      width: 100% !important;
    }
  `]
})
export class ChartComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() type: string;
  @Input() data: any;
  @Input() options: any = {};

  @ViewChild('chartCanvas') canvasRef: ElementRef<HTMLCanvasElement>;

  private chart: Chart;

  ngAfterViewInit(): void {
    this.buildChart();
  }

  ngOnChanges(): void {
    if (this.chart && this.data) {
      this.chart.data = this.data;
      this.chart.update();
    }
  }

  ngOnDestroy(): void {
    if (this.chart) {
      this.chart.destroy();
    }
  }

  private buildChart(): void {
    if (!this.canvasRef?.nativeElement || !this.data) { return; }

    if (this.chart) { this.chart.destroy(); }

    this.chart = new Chart(this.canvasRef.nativeElement, {
      type: this.type,
      data: this.data,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        ...this.options
      }
    });
  }
}